import Dashboard from "../pages/Dashboard/Dashboard";

import AllStudents from "../pages/University/Allstudents";
import NotFound from "../pages/NotFound";
import Enquiryuniversity from "../pages/enquiryleads/leads";
import EnrolledStudents from "../pages/University/Enrolledstudents";
import UploadCourse from "../pages/University/Uploadcourse";

// iocns
import {
  BellIcon,
  BookmarkAltIcon,
  BookOpenIcon,
  BriefcaseIcon,
  DesktopComputerIcon,
  ServerIcon,
  StarIcon,
  SupportIcon,
  UploadIcon,
  UserAddIcon,
  UserGroupIcon,
} from "@heroicons/react/solid";

//admin routs
export const BranchRoutes = [
  {
    name: "Dashboard",
    to: "/dashboard",
    element: <Dashboard />,
    // element: <NotFound />,
    icons: <DesktopComputerIcon className="h-6 text-gray-500 font-sans" />,
  },
  {
    name: "All Students",
    to: "/list/all/students",
    element: <AllStudents />,
    icons: <UserGroupIcon className="h-6 text-gray-500 font-sans" />,
  },
  {
    name: "Enrollments",
    to: "/list/aa/entrolled/students",
    element: <EnrolledStudents />,
    icons: <StarIcon className="h-6 text-gray-500 font-sans" />,
  },
  {
    name: "Upload Course",
    to: "/upload/course",
    element: <UploadCourse />,
    icons: <UploadIcon className="h-6 text-gray-500 font-sans" />,
  },
  {
    name: "Preview Course",
    to: "/preview/courses",
    element: <NotFound />,
    icons: <BookOpenIcon className="h-6 text-gray-500 font-sans" />,
  },

  // {
  //   name: 'Tech Support',
  //   to: '/techsupport',
  //   element: <TechSupport />,
  //   icons: <SupportIcon className="h-6 text-gray-500 font-sans" />,
  // },
];
export const BankRoutes = [
  // {
  //   name: "Bank Journel Entry",
  //   to: "/bjentry",
  //   element: <Bankjournel />,
  //   icons: <BookOpenIcon className="h-6 text-gray-500 font-sans" />,
  // },
  // {
  //   name: "Support",
  //   to: "/support",
  //   element: <TechSupport />,
  //   icons: <SupportIcon className="h-6 text-gray-500 font-sans" />,
  // },
];

export const YasystemRoutes = [
  // {
  //   name: "Dashboard",
  //   to: "/dashboard",
  //   element: <Dashboard />,
  //   icons: <DesktopComputerIcon className="h-6 text-gray-500 font-sans" />,
  // },
  // {
  //   name: "Support",
  //   to: "/support",
  //   element: <TechSupport />,
  //   icons: <SupportIcon className="h-6 text-gray-500 font-sans" />,
  // },
];
